<template>
  <div class="s-layout" :style="colorObject">
    <b-modal id="modal-tip" scrollable centered :hide-header="tip && !tip.title" :hide-footer="tip && !tip.button_text" class="tips">
      <template #modal-header>
        <div class="font-weight-bold h6 mb-0">
          {{ tip.title }}
        </div>
      </template>

      <template #default>
        <button class="tips__close" @click="close()">
          <img src="./images/close.svg" />
        </button>
        <div class="p-2" :style="colorObject">
          <div v-if="tip.content" v-html="tip.content"></div>
        </div>
      </template>
      <template #modal-footer="{ close }">
        <div :style="colorObject" class="flex-fill">
          <SharedButton class="w-100" @click="close()">{{
            tip.button_text
          }}</SharedButton>
        </div>
      </template>
    </b-modal>

    <div class="s-container">
      <template v-if="registrationCheckIsDone">
        <Header
          :meta="meta"
          :show-member-center="false"
          :page-title="getModuleConfig('page_title')"
          :page-image="getModuleConfig('page_image')"
          :page-kv-image="getModuleConfig('page_kv_image')"
          :header-section="getModuleConfig('header_section')"
        />
        <router-view />
      </template>
      <Loading v-else></Loading>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapMutations } from "vuex"
import registerApi from "@/apis/liff/v2/register"
import { themeColorFn } from "@/mixins/liff/themeColor";
import Header from "@/components/Page/Liff/Shared/HeaderV3";
import Loading from "@/components/Page/Liff/Shared/Loading";
import registerMixin from "@/mixins/liff/register";
import SharedButton from "@/components/Page/Liff/Shared/Button";


export default {
  components: {
    Header,
    SharedButton,
    Loading,
  },
  mixins: [themeColorFn({ themeConfigPage: 'register' }), registerMixin],
  data() {
    return {
      tip: null,
      registrationCheckIsDone: false,
    };
  },
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
      from: "route/from",
      hasIntended: "route/hasIntended",
    }),
    intended() {
      if (this.$route.query.redirect_uri) {
        return this.$route.query.redirect_uri
      }

      if (this.$route.query.redirect_url) {
        return this.$route.query.redirect_url
      }

      if (!this.hasIntended) {
        return this.from?.fullPath
      }

      return null
    },
  },
  created() {
    if (this.intended) {
      this.SET_INTENDED(this.intended)
    }
    if (this.$route.query.redirect_action) {
      this.SET_REDIRECT_ACTION(this.$route.query.redirect_action)
    }
    this.SET_BUTTON_DISPLAY({
      redirect_button: this.$route.query.redirect_button ? this.$route.query.redirect_button == 1 : null,
      success_button: this.$route.query.success_button ? this.$route.query.success_button == 1 : null,
      go_to_button: this.$route.query.go_to_button ? this.$route.query.go_to_button == 1 : null,
    })
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == "modal-tip") {
        var uri = window.location.toString();

        if (uri.indexOf("#") > 0) {
          var clean_uri = uri.substring(0, uri.indexOf("#"));

          window.history.replaceState({}, document.title, clean_uri);
        }
      }
    });

    if (this.getModuleConfig("modal_tips")) {
      window.addEventListener("hashchange", () => {
        if (window.location.hash) {
          this.tip = this.getModuleConfig("modal_tips").find(
            (x) => x.id == window.location.hash.substring(1)
          );
          this.$bvModal.show("modal-tip");
        }
      });
    }

    this.checkRegistered()
  },
  methods: {
    ...mapMutations({
      SET_INTENDED: "route/SET_INTENDED",
      SET_REDIRECT_ACTION: "route/SET_REDIRECT_ACTION",
      SET_BUTTON_DISPLAY: "route/SET_BUTTON_DISPLAY",
    }),
    async checkRegistered() {
      const params = Object.keys(this.$route.query).reduce((acc, key) => {
        // 如果 key 轉小寫後，符合 consumerid, sourcesystemcode, nonce，就帶上
        if (["consumerid", "sourcesystemcode", "nonce"].includes(key.toLowerCase())) {
          acc[key.toLowerCase()] = this.$route.query[key]
        }

        return acc
      }, {})

      const response = await registerApi.checkRegistered(params)

      // 記錄是否有待返回的頁面（goSuccess 會清除 Vuex 狀態）
      const willRedirectBack = response?.data?.next === 'registered_page' && this.hasIntended

      try {
        if (['form_page', 'verify_form_page'].includes(response?.data?.next)) {
          await this.$router.push({
            name: "LiffRegisterIndex",
            params: {
              orgCode: this.$route.params.orgCode,
            },
            query: this.$route.query,
          })
        } else {
          await this.goNext(response?.data?.next)
        }
      } catch (error) {
        if (error.name !== 'NavigationDuplicated') {
          console.error(error)
        }
      }

      // 已註冊用戶觸發 redirect 返回原頁面，保持 Loading 不顯示註冊畫面
      if (willRedirectBack) {
        return
      }

      this.registrationCheckIsDone = true
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../../../assets/css/liff/main.css";
@import "../../../assets/css/liff/liff_init_theme_config.css";

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
}

.s-container {
  min-height: 100vh;
}

::v-deep .page {
  padding: 16px 12px;
  background: var(--liff-content_bg_color);
  &__title {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    color: var(--liff-primary_text_color) !important;
  }
  &__desc {
    font-size: 14px;
    line-height: 22px;
    color: var(--liff-secondary_text_color) !important;
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    b {
      color: var(--primary-color) !important;
      font-weight: 600;
    }
  }
  &__content {
    margin: 10px 20px;
  }
  &__button {
    padding: 12px;
    color: var(--liff-primary_text_color) !important;
  }
}

::v-deep .tips {
  &__close {
    position: absolute;
    top: -3rem;
    left: 50%;
    transform: translateX(-50%);
    border: none;
    border-radius: 100%;
    aspect-ratio: 1;
    padding: 10px;
    line-height: 0;
  }
}

::v-deep .modal-content {
  border-radius: 10px;
  font-size: 15px;

  .modal-header,
  .modal-footer {
    border-top: none;
    border-bottom: none;
  }
}

::v-deep .modal-backdrop {
  opacity: 0.5 !important;
}
</style>

<style lang="scss">
@use "@/assets/scss/common/fonts";
</style>